<template>
    <svg
        height="24px"
        width="24px"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        style="fill: currentColor"
    >
        <path
            d="M17,13H7V11H17M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z"
        />
    </svg>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
    name: "check_box_indeterminate",
});
</script>
